import React from "react";
import SearchBoxSelect from "../Dependencies/searchpage/searchBox";

export default function SearchPage(){
    return(
        <div>
        <SearchBoxSelect/>
        </div>
    )
}